export enum AllocationType_Enum {
  Undefined = 0,
  Spread = 1,
  AsFirstPayment = 2,
  FirstPayment = 2,
  FinalPayment = 3
}
